import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import VueRouter from 'vue-router'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from './store/index'
import apiFun from "./network/api";
import Video from '../node_modules/video.js'
import '../node_modules/video.js/dist/video-js.css'
Vue.prototype.$video = Video
Vue.use(VueRouter);
Vue.use(Element);
Vue.config.productionTip = false
new Vue({
  el: '#app',
  store,
  render: h => h(App),
  router: router,
})
Vue.prototype.$apiFun = apiFun; //请求接口api